import React, { useEffect, useState } from 'react'
import { FormCard, FormCardInput } from '../../../components/FormCard'
import { api } from "../../../api"
import { useForm } from 'react-hook-form';
import FormBtn from '../../../components/elements/Buttons/FormBtn';
import GoBackBtn from '../../../components/elements/Buttons/GoBackBtn';
import { selectUserInfo } from '../../../features/users/userInfoSlice';
import { useDispatch, useSelector } from 'react-redux';
import toast from 'react-hot-toast';
import ToastAction from '../../../components/ToastAction';
import { fetchUsers, getUsers } from '../../../features/users/manageUsersSlice';
import { useHistory } from 'react-router-dom';
import { selectorTour } from '../../../features/tour/tourSlice';


const AddUser = () => {
	const history = useHistory()
	const dispatch = useDispatch();
	const [email, setEmail] = useState(null)
	const usersCompany = useSelector(getUsers)
	const isTourLaunched = useSelector(selectorTour)
	const {
		register,
		handleSubmit,
		reset,
		formState: { errors }
	} = useForm({
		mode: 'onTouched',
		shouldFocusError: true
	});
	const userInfoContext = useSelector(selectUserInfo);
	const loadingUsers = useSelector(state => state.users.loading)


	const [loading, setLoading] = useState(false)

	useEffect(() => {
		const user = usersCompany.filter(user => user.email === email)?.[0]
		if (user) history.push(`/account/users/edit/${user.id}`, { user })
	}, [usersCompany])

	async function invite(userToInvite) {
		setLoading(true)
		try {
			await api.user().invite({ ...userToInvite, company_id: userInfoContext?.user?.company_id })
			dispatch(fetchUsers({ company_id: userInfoContext?.user?.company_id }))
			setEmail(userToInvite.email)
			reset()
		} catch (error) {
			console.log(error);
			if (error.message == 'Request failed with status code 400')
				toast.custom(t =>
					<ToastAction
						toastRef={t}
						label='Oups !!'
						description='Cet email a déjà été invité.'
						saraExpression="worried"
					/>
				)
			else toast.custom(t =>
				<ToastAction
					toastRef={t}
					label='Oups !!'
					description='Nous avons rencontré un problème, veuillez réessayer.'
					saraExpression="sorry"
				/>
			)
		}
		setLoading(false)
	}

	return (
		<>
			<GoBackBtn />
			<div className="max-w-xl mx-auto mt-40 flex items-center">
				<form className="step7" onSubmit={handleSubmit(invite)}>
					<FormCard title="Invitation utilisateur">
						<FormCardInput disabled={isTourLaunched} type='email' register={register} label="Email" name="email" errorType={errors?.email?.type} />
						<FormCardInput disabled={isTourLaunched} register={register} label="Prénom" name="name" errorType={errors?.name?.type} />
						<FormCardInput disabled={isTourLaunched} register={register} label="Nom de Famille" name="family_name" errorType={errors?.family_name?.type} />
						<FormBtn label={loading || loadingUsers ? 'Enregistrement...' : 'Choisir ses droits'} disabled={isTourLaunched || loading || loadingUsers} />
					</FormCard>
				</form>
			</div>
		</>
	)
}

export default AddUser